import VirtualAnnouncementStudio from "components/VirtualAnnouncement/VirtualAnnouncementStudio";

export default VirtualAnnouncementStudio;
